import { render, staticRenderFns } from "./FooterEdit.vue?vue&type=template&id=a35c25cc&scoped=true&"
import script from "./FooterEdit.vue?vue&type=script&lang=js&"
export * from "./FooterEdit.vue?vue&type=script&lang=js&"
import style0 from "./FooterEdit.vue?vue&type=style&index=0&id=a35c25cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35c25cc",
  null
  
)

export default component.exports